import Link from "next/link";
import { Button } from "@/components/ui/button";
import { Rocket } from "lucide-react";

export function ComingSoonPage() {
    return (
        <div className="flex min-h-screen items-center justify-center px-4">
            <div className="space-y-6 text-center">
                <div className="flex justify-center">
                    <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-primary/15">
                        <Rocket className="h-8 w-8 text-primary" />
                    </div>
                </div>
                <div>
                    <h1 className="text-2xl font-bold tracking-tight">
                        Launching Soon
                    </h1>
                    <p className="mt-2 text-muted-foreground">
                        PingNG is not yet open for sign-ups. Check back soon!
                    </p>
                </div>
                <Button variant="outline" asChild>
                    <Link href="/">Back to Home</Link>
                </Button>
            </div>
        </div>
    );
}
